<template>
    <span>
        <v-btn
          class="mr-2"
          dense
          color="success"
          outlined
          x-small
          width="80px"
          @click="approveRejectRequest('Approve')"
        >
          Approve
        </v-btn>
        <v-btn
          dense
          color="error"
          outlined
          x-small
          width="80px"
          @click="approveRejectRequest('Reject')"
        >
          Reject
        </v-btn>
    </span>
</template>
<script>
export default {
  name: 'ApproveRejectBtn',
  props: {
    fieldType: {
      type: [String, Number],
      default: null
    },
    fieldValue: {
      type: [String, Number],
      default: null
    },
    approveRowId: {
      type: String,
      default: null
    },
    isChange: {
      type: String,
      default: null
    },
    file: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    approveRejectRequest: function (type) {
      let Obj = { fieldType: this.fieldType, fieldValue: this.fieldValue, file: this.file }
      if (this.approveRowId) {
        Obj.id = this.approveRowId
      }
      if (this.isChange) {
        Obj.isChange = this.isChange
      }
      this.$emit('click', Obj, type)
    }
  }
}
</script>
